/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/extensions
const clientPlugin = require('./dist/client/client-plugin').default;

module.exports = clientPlugin;
